<template>
  <div>
    <div v-if="!loading">
      <Subheader :title="`My Assignments: ${maker.username}`" />

      <div class="app-content-column">
        <div class="card">
          <h5>Needs Attention</h5>
          <!-- Will need to toggle this based on the status of the maker -->
          <p class="bold-text">This user has one or more projects that have not been approved.</p>
          <br />
          <!-- We don't need this until we add in user activation -->
          <!-- <p class="bold-text">To be activated a user must have:</p>
        <ul class="verification-bullets">
          <li>Verified personal location</li>
          <li>Cell phone verification check</li>
          <li>Verified financial information</li>
          <li>Your final approval on the person</li>
        </ul>
          <br />-->
          <p class="bold-text">To be activated, a project must have:</p>
          <ul class="verification-bullets">
            <li>
              Confirmation from you as the Activator that the contact information for the "Maker" is
              correct (by contacting them)
            </li>
            <li>Confirmation of the scope of their project</li>
            <li>A verified project location</li>
          </ul>
          <p>
            You should also confirm the expectation that they will post pictures and updates as
            progress is being made.
          </p>
        </div>

        <div class="card">
          <h5>About</h5>
          <p>Name: {{ maker.fullName ? maker.fullName : '' }}</p>
          <p>Username: {{ maker.username }}</p>
          <p>Email: {{ maker.email ? maker.email : '' }}</p>
          <p>Phone Number: {{ maker.phoneNumber ? maker.phoneNumber : '' }}</p>
          <p>Bio: {{ maker.description ? maker.description : '' }}</p>
        </div>

        <div class="card">
          <h5>Projects</h5>
          <p>All projects for this Maker are below</p>
          <div v-for="project in maker.mUnverifiedProjects" :key="project.id">
            <ProjectCard :project="project"></ProjectCard>
            <div class="button-wrapper" style="justify-content: space-around">
              <router-link
                :to="{
                  name: 'AssignmentsNeedsFurtherReview',
                  params: { projectId: project.id, makerId: maker.id },
                }"
              >
                <button class="large-button">Needs Further Review</button>
              </router-link>
              <button class="large-button" @click="approveProject(project.id)">
                Approve Project
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spinner v-if="loading" />
  </div>
</template>

<script>
import User from '@/services/users'
import Project from '@/services/projects'
import { errorMessage } from '@/services/utils/apiErrors'

import Subheader from '@/components/Subheader'
import ProjectCard from '@/components/ProjectCard'
import Spinner from '@/components/Spinner'

export default {
  name: 'AssignmentsDetail',
  components: {
    Subheader,
    ProjectCard,
    Spinner,
  },
  data() {
    return {
      maker: {},
      loading: false,
    }
  },
  created() {
    this.refreshData()
  },
  methods: {
    async refreshData() {
      const userId = this.$route.params.userId
      this.loading = true
      try {
        const userResponse = await User.api.getUser(userId)
        this.maker = userResponse
      } catch {
        errorMessage()
      } finally {
        this.loading = false
      }
    },
    async approveProject(projectId) {
      try {
        await Project.api.approveProject(projectId)

        this.refreshData()
        this.$Alert.alert({
          type: 'success',
          message: `<h2>Project Approved</h2>`,
          timeout: 3000,
        })
      } catch {
        this.$Alert.alert({
          type: 'error',
          message: `<h2>Error in Project Approval</h2>`,
          timeout: 3000,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/cards';
@import '../styles/mixins/containers';
@import '../styles/mixins/buttons';
@import '../styles/layout';

.card {
  @include card-w-borders();
  align-items: center;
  margin-top: 1.25rem;
}

.bold-text {
  font-family: $base-bold-font-family;
  margin-bottom: unset;
}

.verification-bullets {
  margin-left: 2rem;
}

li {
  margin-bottom: 1rem;
  line-height: 1.4rem;
  margin-top: 1rem;
  list-style-type: circle;
}

.needs-review-btn {
  @include large-button-inverted();
}

.btn-container {
  justify-content: center;
  margin-top: 20px;
  width: inherit;
  text-align: center;
}
</style>
